module.exports = __webpack_public_path__ + "static/media/il-no-artifacts@2x.6243a391.png";